__turbopack_context__.v({
  "close": "GallerySliderModal-module-scss-module__NkiDra__close",
  "content": "GallerySliderModal-module-scss-module__NkiDra__content",
  "contentHidden": "GallerySliderModal-module-scss-module__NkiDra__contentHidden",
  "cursorImg": "GallerySliderModal-module-scss-module__NkiDra__cursorImg",
  "imgNoCursor": "GallerySliderModal-module-scss-module__NkiDra__imgNoCursor",
  "imgWrapper": "GallerySliderModal-module-scss-module__NkiDra__imgWrapper",
  "nav": "GallerySliderModal-module-scss-module__NkiDra__nav",
  "nav__counter": "GallerySliderModal-module-scss-module__NkiDra__nav__counter",
  "selector": "GallerySliderModal-module-scss-module__NkiDra__selector",
  "selector__active": "GallerySliderModal-module-scss-module__NkiDra__selector__active",
  "selector__arrow": "GallerySliderModal-module-scss-module__NkiDra__selector__arrow",
  "selector__arrow_down": "GallerySliderModal-module-scss-module__NkiDra__selector__arrow_down",
  "selector__list": "GallerySliderModal-module-scss-module__NkiDra__selector__list",
  "selector__switch": "GallerySliderModal-module-scss-module__NkiDra__selector__switch",
  "swiper": "GallerySliderModal-module-scss-module__NkiDra__swiper",
  "swiperAnimated": "GallerySliderModal-module-scss-module__NkiDra__swiperAnimated",
  "swiperSlide": "GallerySliderModal-module-scss-module__NkiDra__swiperSlide",
});
